import React from 'react';
import PropTypes from 'prop-types';

const CustomFormInput = ({ register, dirtyFields, fieldName, errorMessage, readOnly }) => {

  // determine which css classes we'll apply to this field
  const inputClasses = []
  if (errorMessage)
    inputClasses.push('is-invalid')
  else if (dirtyFields && dirtyFields[fieldName])
    inputClasses.push('is-valid')

  if (readOnly)
    inputClasses.push('form-control-plaintext')
  else
    inputClasses.push('form-control')

  return (
    <>
      <input className={inputClasses.join(' ')}
        {...register(fieldName)}
        readOnly={readOnly}
        aria-invalid={errorMessage ? "true" : "false"}
      />
      {errorMessage && <p role="alert">{errorMessage}</p>}
    </>
  );
};

CustomFormInput.propTypes = {
  fieldName: PropTypes.string.isRequired,  // name of the field
  dirtyFields: PropTypes.object,            // an array of which fields in the form are considered 'dirty'
  errorMessage: PropTypes.string,          // an error message if this field is failing validation
  register: PropTypes.func.isRequired      // used by react-hook-form 
};

export default CustomFormInput;